module.exports = {
    DEBUG: {
        //SHOW_LANDING: false,
    },
    API: {
    },
};